module.exports = __webpack_public_path__ + "img/search.90823443.svg";